/*
  CDXMT-9: "Share cart" link. See snippets/cart-share.liquid.

  The link is a Shopify cart permalink with storefront=true, so whoever opens
  it lands on the cart page (CDXMT-106 Sho gate and quote/PO link still apply)
  with a cart of their own.

  Rep attribution: ?rep=Name on any page stores the name in this browser
  (?rep=off clears it); a customer tagged 'sales-rep' counts while logged in.
  The rep's name then rides along as a cart attribute and referral code.
*/
(function () {
  if (window.cdCartShare) return;
  window.cdCartShare = true;

  var KEY = 'cdSalesRep';

  function store(fn) {
    try { return fn(window.localStorage); } catch (e) { return null; }
  }

  var param = new URLSearchParams(window.location.search).get('rep');
  if (param !== null) {
    var clean = param.replace(/[^\w .'-]/g, '').trim().slice(0, 40);
    if (clean === '' || clean.toLowerCase() === 'off') {
      store(function (s) { s.removeItem(KEY); });
    } else {
      store(function (s) { s.setItem(KEY, clean); });
    }
  }

  function repName() {
    var tagged = document.querySelector('[data-customer-rep]');
    if (tagged) return tagged.getAttribute('data-customer-rep');
    return store(function (s) { return s.getItem(KEY); });
  }

  function slug(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function buildLink(cart, base, rep) {
    var lines = cart.items.map(function (item) {
      return item.variant_id + ':' + item.quantity;
    });
    var params = new URLSearchParams();
    params.set('storefront', 'true');
    if (rep) {
      params.set('attributes[Sales rep]', rep);
      params.set('ref', 'rep-' + slug(rep));
    }

    // Permalinks can't carry per-line properties (e.g. "Sho 90-day trial"),
    // so they go in the order note alongside any note already on the cart.
    var notes = [];
    if (cart.note) notes.push(cart.note);
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      Object.keys(props).forEach(function (key) {
        if (key.charAt(0) === '_' || props[key] === '' || props[key] == null) return;
        notes.push(item.product_title + ': ' + key + ': ' + props[key]);
      });
    });
    if (notes.length) params.set('note', notes.join('\n'));

    var codes = (cart.discount_codes || [])
      .filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
    if (codes.length) params.set('discount', codes.join(','));

    return base.replace(/\/$/, '') + '/cart/' + lines.join(',') + '?' + params.toString();
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return Promise.reject();
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Opening a share link redirects to /cart?cart_link_id=..., which only shows
  // the opener's own cart, so copying it from the address bar re-creates the
  // original bug. For anyone who arrived from a share link (or is in rep mode),
  // keep the address bar on the cart page carrying the share link after the #
  // (/cart#<variant>:<qty>,...?storefront=true...). The path stays /cart
  // because the theme's cart code re-renders from location.pathname. Opening a
  // copied /cart#... forwards to the real permalink; refreshing is safe since a
  // permalink replaces the cart rather than adding to it.
  var SYNC_KEY = 'cdCartLinkSync';
  var query = new URLSearchParams(window.location.search);
  var onCartPage = /\/cart\/?$/.test(window.location.pathname);
  var linkInHash = /^#\d+:\d+/.test(window.location.hash);

  if (onCartPage && linkInHash && !query.has('cart_link_id')) {
    window.location.replace(root() + 'cart/' + window.location.hash.slice(1));
    return;
  }
  if (query.has('cart_link_id')) {
    try { window.sessionStorage.setItem(SYNC_KEY, '1'); } catch (e) {}
  }
  var syncOn = false;
  try { syncOn = window.sessionStorage.getItem(SYNC_KEY) === '1'; } catch (e) {}

  function syncAddressBar() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hash = cart.items.length ? '#' + buildLink(cart, '', repName()).slice('/cart/'.length) : '';
        window.history.replaceState(window.history.state, '', window.location.pathname + hash);
      })
      .catch(function () {});
  }

  if (onCartPage && (syncOn || repName())) {
    syncAddressBar();
    // Re-sync after anything on the page changes the cart, and when the tab
    // comes back into focus (the cart may have changed in another tab).
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var result = nativeFetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        result.then(function () { setTimeout(syncAddressBar, 300); }, function () {});
      }
      return result;
    };
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') syncAddressBar();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-share-create]');
    if (!button) return;
    var panel = button.closest('[data-cart-share]');
    var label = panel.querySelector('[data-cart-share-label]');
    var field = panel.querySelector('[data-cart-share-url]');

    function flash(text) {
      label.textContent = text;
      clearTimeout(button._cartShareTimer);
      button._cartShareTimer = setTimeout(function () { label.textContent = 'Share cart'; }, 2500);
    }

    button.disabled = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return;
        var url = buildLink(cart, panel.getAttribute('data-shop-url'), repName());

        var shared = navigator.share
          ? navigator.share({ title: 'Clear Digital cart', url: url })
          : Promise.reject();
        return shared.catch(function (err) {
          if (err && err.name === 'AbortError') return;
          return copy(url).then(
            function () { flash('Link copied'); },
            function () {
              field.value = url;
              field.hidden = false;
              field.select();
            }
          );
        });
      })
      .catch(function () { flash('Try again'); })
      .finally(function () { button.disabled = false; });
  });
})();
